import { buildProps as i } from "./index601.js";
import o from "./index713.js";
const t = i({
  /**
   * @description native `aria-label` attribute
   */
  ariaLabel: String,
  /**
   * @description native `aria-orientation` attribute
   */
  ariaOrientation: {
    type: String,
    values: ["horizontal", "vertical", "undefined"]
  },
  /**
   * @description native `aria-controls` attribute
   */
  ariaControls: String
}), e = (r) => o(t, r);
export {
  t as ariaProps,
  e as useAriaProps
};
